export const READABLE_DATE_FORMAT = "DD MMMM YYYY";

export const STATISTICS_PERIOD = 24;
export const STATISTICS_PERIOD_UNIT = "hours";

export const MAX_PORTFOLIO_PRECISION = 6;

export const MAX_API_KEYS = 3;

export const UI_FORMATTERS = {
  BTC_PRECISION_MANTISSA: 6,
  DATE_FORMAT: "YYYY-MM-DD",
  DATE_TIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
  LONG_PRECISION_MANTISSA: 8,
  MAX_PRECISION_MANTISSA: 20,
  ROUNDING_RULES: {
    DEFAULT: 0,
    LONG_PRECISION: 1,
    SHORT_PRECISION: 2,
    CUSTOM_PRECISION: 3,
    MAX_PRECISION: 4,
  },
  CUSTOM_PRECISION: 3,
  DEFAULT: 0,
  LONG_PRECISION: 1,
  MAX_PRECISION: 4,
  SHORT_PRECISION: 2,
  SHORT_PRECISION_MANTISSA: 2,
  TIME_FORMAT: "HH:mm:ss",
};

export const TRANSFER_STATUS = {
  NEW: 0,
  SUCCESS: 1,
  FAILURE: 2,
};

export const WITHDRAW_STATUS = {
  NEW: 0,
  SUCCESS: 1,
  FAILURE: 2,
};

export const TRANSACTION_STATUS = {
  COMPLETED: 0,
  PENDING: 1,
  IN_PROGRESS: 2,
  FAILED: 3,
  AWAITING_APPROVAL: 4,
  SETTLED: 5,
  ROLLBACK: 6
};

export const TRANSACTION_TYPE = {
  PAYIN: "payin",
  PAYOUT: "payout",
  TRANSFER: "transfer",
  DEPOSIT: "deposit",
  WITHDRAW: "withdraw",
};

export const TRANSACTION_SIDE = {
  ZERO: 0,
  POSITIVE: 1,
  NEGATIVE: -1,
};

export const TRANSACTIONS_HASH_IDENTIFIERS = [
  "0x",
  "r",
  "X",
  "1",
  "3",
  "bc1",
  "T",
];

export const TRANSACTIONS_WEB_SITES_BY_IDENTIFY = {
  "0x": "https://etherscan.io/tx/",
  r: "https://xrpscan.com/tx/",
  X: "https://xrpscan.com/tx/",
  1: "https://www.blockchain.com/btc/tx/",
  3: "https://www.blockchain.com/btc/tx/",
  bc1: "https://www.blockchain.com/btc/tx/",
  T: "https://tronscan.org/#/transaction/",
};

export const TRADE_SIDE = {
  BUY: 1,
  SELL: -1,
};

export const API_KEY_STATUS = {
  ACTIVE: "active",
  DELETED: "deleted",
  BLOCKED: "blocked",
};

export const WEBSOCKET_EVENTS = {
  SUBSCRIPTION_ID_GENERATED: "subscription-id-generated",
  BALANCES_UPDATED: "balances-updated",
  AUTHORIZE_SUCCESS: "authorize-success",
  UNAUTHORIZED: "unauthorized",
  PING: "ping",
  PONG: "pong",
  SEND_ACTIVE_PORTFOLIO: "change-active-portfolio",
  PRICES_UPDATED: "prices-updated",
  SEND_TOKEN: "authorize",
  NOTIFICATION_CREATED: "notification-created",
  AGGREGATED_PARAMETER_REMOVED: "aggregated-params-deleted",
  AGGREGATED_PARAMETER_UPDATED: "aggregated-params-updated",
  POSITION_REMOVED: "position-deleted",
  POSITION_UPDATED: "position-updated",
  COLLATERAL_UPDATED: "collateral-updated",
  TRANSACTIONS_CREATED: "transactions-created",
  TRANSACTIONS_UPDATED: "transactions-updated",
  TRADES_CREATED: "trades-created",
  TRADING_ORDERBOOK_UPDATED: "trading-orderbook-updated",
  TRADING_LAST_CANDLE_UPDATED: "trading-last-candle-updated",
  TRADING_ORDER_UPDATED: "trading-order-updated",
};

export const USER_STATUS = {
  PENDING_EMAIL_CONFIRMATION: 0,
  PENDING_KYC: 1,
  KYC_REJECTED: 2,
  DISABLED: 3,
  ACTIVE: 4,
};

export const TETHER_CHAINS_CURRENCIES = ["USD", "USDT20", "USDTRX", "USDT"];

export const WEBSOCKET_INTERVALS = {
  BALANCE_UPDATE: 10000,
  TRANSACTIONS_DEBOUNCE: 1000,
  TRADES_DEBOUNCE: 1000,
};

export const SMALL_BALANCES = {
  BTC: 0.01,
  ETH: 0.1,
  USDT: 100,
};
